import { RADIO_INFO } from '../../data/propertyType/constant';
import Section from '../util/Section';
import RadioButton from './RadioButton';

export default function PropertyType() {
  return (
    <>
      <Section title="Property Type">
        <RadioButton RADIO_INFO={RADIO_INFO} />
      </Section>
    </>
  );
}
